<template>
  <span class="badge ms-1 d-none d-lg-inline"
    v-if="isAuthenticated"
    :class="{
      'bg-danger': isPrivileged === true,
      'bg-light': isPrivileged === false,
      'text-dark': isPrivileged === false
    }"
    >
    {{ role?.substring(0, 4) || 'NO ROLE' }}
  </span>

  <button v-if="!isAuthenticated" class="btn btn-primary btn-sm ms-3" type="button" @click="loginRedirect">Prijava</button>
  <button v-else class="btn btn-outline-warning btn-sm ms-3" type="button" @click="logoutRedirect">Odjava</button>
</template>

<script setup>
/* global VueRouter */
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"

import { useAuth, isAuthenticated, role } from "../composition-api/useAuth"

/* */

defineOptions({ name: "SignInOutButton" })

const { login, logout } = useAuth()

const loginRedirect = () => login()

const logoutRedirect = () => logout()

const isPrivileged = computed(
  () => role.value === "Administrator" || ["Leader", "Worker"].some((r) => role.value?.startsWith(r)),
)
</script>
